c<app-pop-up>
    <app-pop-up-header 
      [headerName]="viewLogHeaderName"
      (close)="cancel()"
    ></app-pop-up-header>
  

    <div *ngIf="viewLogArray" class="view-log-container">
      <div  class="view-log-add-margin"  *ngFor="let viewlog of viewLogArray; let i = index">
        <span class="view-log-name" >{{viewlog.firstName}} {{viewlog.lastName}}</span>
        <span class="view-log-action-taken"> - {{viewlog.tab}} {{viewlog.actionTaken}} - {{viewlog.updatedOn}}</span>
        </div>
    </div>
    <app-pop-up-footer>
        <app-button
        [name]="'Close'"
        [type]="'outlined'"
        (btnClick)="cancel()"
      ></app-button>
    </app-pop-up-footer>
  </app-pop-up>
  